export default {
  data() {
    return {
      priorityOptions: [
        "P0",
        "P1",
        "P2",
        "P3",
        "P4",
        "P5",
        "P6",
        "P7",
        "P8",
        "P9"
      ]
    };
  }
};
